import classNames from 'classnames';
import { strings } from '@/i18n/strings';
import styles from './Logo.module.scss';

type Props = {
	size?: number;
	onDark?: boolean;
	className?: string;
};

export const Logo = ({ size = 30, onDark = false, className }: Props) => (
	<img
		src={onDark ? '/images/logo.png' : '/images/logo-on-light.png'}
		alt={strings.logo.alt}
		className={classNames(styles.logo, className)}
		height={size}
		draggable={false}
	/>
);
